export default __webpack_public_path__ + "app/views/statements/overview.html";